/**
 * Auto-assigned sequence number for a plant-scoped master record (Reason,
 * Component, Operator), scoped per plant so each plant's records number
 * independently (1, 2, 3...), including a shared "no plant assigned" bucket
 * for customers that haven't configured Plant Groups.
 */
export function nextPlantSequenceCode(items, plantCode) {
  const scoped = items.filter((i) => (i.plant_code || undefined) === (plantCode || undefined));
  return Math.max(0, ...scoped.map((i) => Number(i.code) || 0)) + 1;
}

/** Resolve a plant code to its display name via a { code, name }[] list. */
export function resolvePlantName(plantOptions, plantCode) {
  if (!plantCode) return undefined;
  const match = (plantOptions || []).find((p) => p.code === plantCode);
  return (match && (match.name || match.label)) || plantCode;
}
